import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines, faClipboardList } from '@fortawesome/free-solid-svg-icons';

/**
 * Segmented pill toggle that switches the Report Layouts sidebar (and right
 * pane) between the Templates/Layouts view and the Forms view. Themed to match
 * the rest of the sidebar (backgrounds-primary / texts-secondary palette).
 */
const FormsModeToggle = ({ mode, setMode }) => {
    const segments = [
        { key: 'templates', label: 'Templates/Layouts', icon: faFileLines },
        { key: 'forms', label: 'Forms', icon: faClipboardList },
    ];

    return (
        <div className='w-full flex items-center p-1 rounded-xl bg-backgrounds-white border border-backgrounds-border'>
            {segments.map((segment) => {
                const isActive = mode === segment.key;
                return (
                    <button
                        key={segment.key}
                        type='button'
                        onClick={() => setMode(segment.key)}
                        className={`flex-1 flex items-center justify-center px-2 py-1.5 rounded-lg text-sm font-semibold truncate transition-all duration-200 ${
                            isActive
                                ? 'bg-backgrounds-primary100 text-backgrounds-primary300 shadow-inner'
                                : 'text-texts-secondary300 hover:bg-backgrounds-primary100/50'
                        }`}
                        title={segment.label}
                    >
                        <FontAwesomeIcon
                            icon={segment.icon}
                            className='mr-2 drop-shadow-sm'
                        />
                        <span className='truncate'>{segment.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default FormsModeToggle;
